import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { 
    IonContent, IonModal, IonIcon
} from '@ionic/angular/standalone';

import { DemoozModalService } from '@demooz/services';

@Component({
    selector: 'demooz-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    imports: [IonContent, IonModal, IonIcon]
})
export class DemoozModalComponent  implements OnInit {

    @Input({alias : 'size', required : false}) size: 'small'|'medium'|'big'|'full' = 'medium';
    @Input({alias : 'heightAuto', required : false}) heightAuto: boolean = true;
    @Output() onDidDismiss = new EventEmitter<any>();

    @ViewChild('modal') modal: IonModal;
    
    constructor(
        private demoozModalService: DemoozModalService
    ) { }

    ngOnInit() {
        
    }
    
    open() {             
        this.demoozModalService.open(this.modal);
    }
    
    async dismiss() {        
        await this.modal.dismiss();
    }
    
    async canDismissMediaModal(data?: any, role?: string) {
        return role !== 'gesture';
    }
    
    async onDidDismissMediaModal($event: any){ 
        this.demoozModalService.onDidDismiss($event);
        this.onDidDismiss.emit($event);
    }
}
